// extracted by mini-css-extract-plugin
export default {"table":"rYyC6nHFAp5MsxerOeDd","regularRow":"XjhsbzDRMxc2mryfWNSV","totalRow":"tmWunYbqryVsZTTfkLgf","nestedTable":"dyTIs23Z9_EzFwkcIzaC"};